// Brand logos are served from /public (not bundled) so index.html can preload
// them and every screen - loader, lead form, home, tour, plan - shares one
// cached copy.
export const COMPANY_LOGO = "/companylogo.webp";
export const PROJECT_LOGO = "/aurora-hills-logo-white.webp";
